import { createFileRoute } from "@tanstack/react-router";

import { PackagesSettings } from "../components/settings/PackagesSettings";

export const Route = createFileRoute("/settings/packages")({
  component: PackagesSettings,
});
